@if (initialized && kpiHeaderDto) {

    <kpi-header [itemsArray]="kpiHeaderDto" [breadcrumb]="items" configRoute="/cm/config"
    ></kpi-header>


}